import { useUserSlippageTolerance } from 'state/user/hooks'
import Swap from '../views/Swap'

const SwapPage = () => {
  return <Swap />
}

export default SwapPage
